<script>
import { onMount } from 'svelte';
import * as utils from '../utils';
import * as user from '../user.js';
import { push, querystring, link, replace } from 'svelte-spa-router'
import firebase from '../firebase';
import qs from 'qs';
import Header from './header.svelte';

let linkError = false;


onMount(() => {

    const params = qs.parse($querystring);
    firebase.auth().checkActionCode(params.oobCode).then((info) => {

        if (info.operation === 'PASSWORD_RESET')
        {
            replace('/reset?' + $querystring);
        }
        else if (info.operation === 'VERIFY_EMAIL')
        {
            // make sure they are signed in
            user.GetAuthOnly().then((authUser) =>
            {
                const params = qs.parse($querystring);
                if (authUser)
                {
                    if (authUser.email === info.data.email)
                    {
                        // go ahead and verify the email
                        firebase.auth().applyActionCode(params.oobCode).then((resp) => {
                            utils.log('Email Verify successful', authUser.email);

                            // we need to update the user's state
                            user.Update(authUser.uid, {signUpState:'needsinfo'}).then(() =>
                            {
                                // ok now we can move to the info page
                                replace('/signup/info');
                            })
                            .catch((error) =>
                            {
                                utils.error('Verify Error', error);
                            });

                        })
                        .catch((error) => 
                        {
                            console.log('Error verifying', error);
                            linkError = true;
                        });
                    }
                    else
                    {
                        console.log('Error the emails do not match');
                        linkError = true;
                    }
                }
                else
                {
                    utils.RequestSignIn('/link', $querystring);
                }

            });
        }

    })
    .catch((error) =>
    {
        console.log('what is this error?', error);      
        if (error.code === 'auth/invalid-action-code')
        {
            // TODO: handle this better or something
        }
        else if (error.code === 'auth/expired-action-code')
        {

        }
        linkError = true;
    });

    return;



});
</script>
<Header/>

<div class='container medium main'>
{#if linkError}
    <h2>
    Oops. It looks like this link has expired.
    </h2>
    <p>If you are having issues <a href="/contact" use:link>contact support</a></p>
{:else}
    <h2>
        Loading....
        <div class="spinner"></div>
    </h2>
{/if}

</div>


<style>
h2, p {
    color: white;
    text-align: center;
}

</style>



